import script from "./HistoryPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./HistoryPage.vue?vue&type=script&lang=ts&setup=true"

import "./HistoryPage.vue?vue&type=style&index=0&id=9e88da88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e88da88"]])

export default __exports__